import { useDispatch, useSelector } from "react-redux";
import DynamicIcon from "../Form/FormFields/DynamicIcon";
import { useEffect, useState } from "react";
import CustomModal from "../ui/CustomModal";
import DynamicLoader from "../Form/FormFields/DynamicLoader";
import CustomTable from "../ui/CustomTable";
import RuralDetailsCount from "../ruralDetailsCount/RuralDetailsCount";
import { setPidChartId, setStatusBarPopupId } from "../applicationStatus/store";

function StatusGrid(props) {
  const selectorData = useSelector((state: any) => state.time?.tabs);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch()

  const approved_balance_count = props?.propsData?.has_tab ?
    props?.data?.[0]?.[
      `approved_${selectorData[1]?.title?.toLowerCase()}`
    ]  : props?.data?.[0] && props?.data?.[0][Object.keys(props?.data[0])[0]] || "0";
  const rejected_balance_count =

    props?.propsData?.has_tab  ?
    props?.data?.[0]?.[
      `rejected_${selectorData[1]?.title?.toLowerCase()}`
    ] : props?.data?.[0] && props?.data?.[0][Object.keys(props?.data[0])[1]] || "0";

  const pending_balance_count =
    props?.propsData?.has_tab ?
      props?.data?.[0]?.[
        `pending_${selectorData[1]?.title?.toLowerCase()}`
      ]  : props?.data?.[0] && props?.data?.[0][Object.keys(props?.data[0])[2]] || "0";

  const statusList = [
    {
      label: "Approved",
      value: approved_balance_count,
      iconColor: "text-[#0BB783]",
      bgColor: "bg-[#D7F9EF]",
      iconName: "LibraryBig",
    },
    {
      label: "Rejected",
      value: rejected_balance_count,
      iconColor: "text-[#F64E60]",
      bgColor: "bg-[#FFE2E5]",
      iconName: "ChartNoAxesColumn",
    },
    {
      label: "Pending",
      value: pending_balance_count,
      iconColor: "text-[#F64E60]",
     bgColor: "bg-orange-200",
      iconName: "LayoutGrid",
    },
  ];

    const fetchPopupData = async (id: string) => {
      if (id) {
        await dispatch(setStatusBarPopupId(id));
      }

      await RuralDetailsCount(
        selectCompontData?.popup_chart_id,
        chartListData?.id
      );
    };
  return (
    <div className="mt-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {statusList.map((item, index) => (
          <div key={index} className="flex items-center gap-3">
            <div
              className={`flex items-center justify-center ${item.bgColor} px-2 py-2 rounded-lg`}
            >
              <DynamicIcon
                name={item.iconName}
                className={`w-5 h-5 ${item.iconColor}`}
              />
            </div>
            <div>
              <p className="text-[14px] font-bold">{item.value}%</p>
              <p className="text-[9px] font-light">{item.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* <CustomModal
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        title="Chart Detail"
      >
        <div>
          {isLoading ? (
            <DynamicLoader loading={isLoading} />
          ) : (
            <CustomTable
              columns={
                selectorData?.[selectCompontData?.popup_chart_id]?.columns
              }
              rows={selectorData[selectCompontData?.popup_chart_id]?.rows}
              fetchData={selectorData[selectCompontData?.popup_chart_id]}
              key={selectorData[selectCompontData?.popup_chart_id]}
              applicationStatusData={fetchPopupData}
              id={selectCompontData?.popup_chart_id}
            />
          )}
        </div>
      </CustomModal> */}
    </div>
  );
}

export default StatusGrid;
